import React, { useContext } from "react";
import "../AccountMaintenance.css";
import NoDataPlaceholder from "../../../components/element/NoDataPlaceholder";
import Loader from "../../../components/element/Loader";
import ErrorPopup from "../../../components/element/ErrorPopup";
import { FormOutlined, DeleteOutlined } from "@ant-design/icons";
import { FBO_CUSTOMER_ROLE } from "../../../utils/constants";
import { handleEmptyValue } from "../../../utils/utils";
import { StorageContext } from "../../../services/StorageProvider";

const AccountUpdateTable = ({
  accountUpdateData,
  indexStartFrom,
  isLoading,
  error,
  onClickEdit,
  onClickDelete,
}) => {
  const { fboUserProfileData } = useContext(StorageContext);
  if (error) {
    if (error.status === 404) {
      return <NoDataPlaceholder />;
    } else {
      return <ErrorPopup children={error.message}></ErrorPopup>;
    }
  }

  if (isLoading) {
    return <Loader />;
  }

  if (accountUpdateData && accountUpdateData.length === 0) {
    return <NoDataPlaceholder />;
  }

  const getActionRole = (value) => {
    const status = FBO_CUSTOMER_ROLE.find((status) => status.value === value);
    return <div>{status?.name}</div>;
  };
  const isOwnAccount = (item) => {
    return fboUserProfileData?.id && item?.id === fboUserProfileData?.id;
  };
  return (
    <div className="account-maintenance-table-parent-container">
      <div className="account-maintenance-table-container">
        <table className="account-maintenance-table">
          <thead>
            <tr>
              <th>No.</th>
              <th>Name</th>
              <th>Email</th>
              <th>Account Type</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {accountUpdateData?.content?.map((item, index) => (
              <tr key={index}>
                <td>{indexStartFrom + (index + 1)}</td>
                <td>{`${item?.firstName} ${item?.lastName}`}</td>
                <td>{handleEmptyValue(item?.email)}</td>
                <td>{getActionRole(item?.associations[0]?.role)}</td>
                <td>
                  <div className="account-update-table-action-container">
                    <div
                      className="account-update-table-action account-update-table-edit"
                      onClick={() => onClickEdit(item)}
                    >
                      <FormOutlined />
                    </div>
                    <div
                      className={`account-update-table-action account-update-table-delete ${
                        isOwnAccount(item) ? "disabled" : ""
                      }`}
                      onClick={() =>
                        isOwnAccount(item) ? null : onClickDelete(item)
                      }
                    >
                      <DeleteOutlined />
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AccountUpdateTable;
